ACC.recentlyviewedproducts = {

  rvbindAll: function() {
    var rvcardWidth = '';

    ACC.recentlyviewedproducts.rvgetProdData();

    if ($('.ph-recentlyviewed-products li').length > 0) {
      if ($(window).width() > 600) {
        ACC.recentlyviewedproducts.rvcardsCarousel();
      } else {
        rvcardWidth = $('.ph-suggested-products__jcarousel').innerWidth() / 2;

        $('.ph-recentlyviewed-products').find('li').css('width', rvcardWidth + 'px');
        $('.ph-mob-recent').removeClass('hidden');
        $('.ph-desk-recent').addClass('hidden');
      }
    }

    ACC.recentlyviewedproducts.rvactivePage();
  },

  rvgetProdData: function() {
    var rvprodCodes = [];

    $('.ph-recentlyviewed-products li').each(function() {
      var rvcurrentCtn = $(this).attr('data-prodid');

      if (rvcurrentCtn) {
        rvprodCodes.push(rvcurrentCtn);
      }
    });

    if (rvprodCodes.length > 0) {
      $.ajax({
        type: 'POST',
        url: ACC.config.encodedContextPath + '/asyncproduct/getprodutsdata',
        dataType: 'json',
        data: {
          ctvs: rvprodCodes.toString()
        },
        success: function(resultList) {
          var indx = 0;
          var codes = [];

          if (Array.isArray(resultList) && resultList.length > 0) {
            for (indx; indx < resultList.length; indx = indx + 1) {
              ACC.recentlyviewedproducts.rvbindData(resultList[indx]);
              codes.push(resultList[indx].code);
            }
          }

          ACC.recentlyviewedproducts.rvgetPrice(codes);
        }

      });
    }
  },

  rvgetPrice: function(prodcodes) {
    $.ajax({
      type: 'POST',
      url: ACC.config.encodedContextPath + '/asyncproduct/getpricedata',
      dataType: 'json',
      data: {
        codes: prodcodes.toString()
      },
      success: function(resultList) {
        var indx = 0;

        if (Array.isArray(resultList) && resultList.length > 0) {
          for (indx; indx < resultList.length; indx = indx + 1) {
            ACC.recentlyviewedproducts.rvbindPrice(resultList[indx]);
          }
        }
      }

    });
  },

  checknull: function(recently) {
    if (recently) {
      return recently;
    }

    return '';
  },
  /* eslint-disable max-statements*/
  rvbindData: function(rvitem) {
    var rvids = rvitem.ctv.replace('/', '-'),
        qtyUnits = rvitem.numberContentUnits,
        twelveNc = $('#ph-12ncstr').val(),
        eantxt = $('#ph-eanstr').val(),
        prodsapEan = rvitem.sapEan,
        emptytxt = $('.ph-notAvailTxt').val(),
        arrayofdchain = 0;

    arrayofdchain = ACC.decisionPageInfiniteLoader.checkdchainInList();

    if (prodsapEan === null) {
      prodsapEan = emptytxt;
    }

    $('#' + rvids).find('.ph-product-url').attr('href', ACC.config.encodedContextPath + rvitem.url);
    $('#' + rvids).find('.ph-product-image').attr('src', rvitem.imageURL + '&wid=145&hei=145&$jpglarge$');
    $('#' + rvids).find('.ph-product-skustr').html(twelveNc);
    $('#' + rvids).find('.ph-product-sku').html(rvitem.code);
    $('#' + rvids).find('.ph-product-eanstr').html(eantxt);
    $('#' + rvids).find('.ph-product-ean').html(prodsapEan);
    $('#' + rvids).find('.ph-product-title').html(ACC.recentlyviewedproducts.checknull(rvitem.displayName));
    $('#ph-rvprodcode-' + rvids).attr('data-prodid', rvitem.code);

    if (rvitem.numberContentUnits) {
      $('#' + rvids).find('.ph-pkgqty').html(rvitem.numberContentUnits + ' ');
      $('#' + rvids).find('.ph-pkgunit').html(rvitem.unit);
    } else {
      $('#' + rvids).find('.ph-product-inpackage').parent().hide();
    }

    if (parseInt(qtyUnits, 10) > 0) {
      $('#' + rvids).find('.ph-packageCount').removeClass('hidden');
    }

    $('#' + rvids).find('.ph-product-price').attr('id', rvitem.code);

    if (rvitem.newProductFlag) {
      $('#' + rvids).find('.ph-new-indicator').show();
    }

    if ($.inArray(rvitem.dchainValue, arrayofdchain) !== -1) {
      $('#' + rvids).find('.ph-dchainvalue' + rvitem.dchainValue).removeClass('ph-d-none');
    }
  },
  /* eslint-enable max-statements*/
  rvbindPrice: function(rvitem) {
    var $isPromotionEnabled = $('.ph-promotionenabled'),
        prodPriceList = rvitem.priceList,
        rowPrice = '',
        priceIndx = '',
        priceRec = '',
        recString = '',
        ribbonText = '',
        discRibbon = '',
        discVal = rvitem.discountPromotion;

    if (prodPriceList.length > 0) {
      for (priceIndx = 0; priceIndx < prodPriceList.length; priceIndx = priceIndx + 1) {
        rowPrice = prodPriceList[priceIndx];

        priceRec = rowPrice.formattedValue + ' ';
        recString = 'ph-recentlyviewed-products-wrapper #';

        ribbonText = $('#' + recString + rvitem.code).parent().parent().prev().find('.ph-discount-ribbon__text').html();

        if (rowPrice.priceType === 'FROM' && $isPromotionEnabled.length > 0) {
          $('#' + recString + rvitem.code).find('.ph-strike-price').show();
          $('#' + recString + rvitem.code).find('.ph-strike-price').text(priceRec);
          $('#' + recString + rvitem.code).parent().parent().prev().find('.ph-discount-ribbon').show();

          discRibbon = $('#' + recString + rvitem.code).parent().parent().prev().find('.ph-discount-ribbon__text');

          discRibbon.html(ribbonText.replace('0', discVal));
        } else if (rowPrice.priceType === 'BUY' && rowPrice.pricingConditionCode !== 'YLRR') {
          $('#' + recString + rvitem.code).find('.ph-list-price').text(priceRec);
        }
      }
    }
  },

  rvresizeAll: function() {
    var rvimageHeight = 0,
        rvcontentHeight = 0,
        $listItems = $('.ph-recentlyviewed-products').find('li');

    $listItems.each(function() {
      var rvcheight = $(this).find('.ph-card-image-wrapper').outerHeight();
      var rvoheight = $(this).find('.ph-card-product-details').outerHeight();

      if (rvimageHeight < rvcheight) {
        rvimageHeight = rvcheight;
      }

      if (rvcontentHeight < rvoheight) {
        rvcontentHeight = rvoheight;
      }
    });

    $listItems.find('.ph-card-image-wrapper').height(rvimageHeight);
    $listItems.find('.ph-card-product-details').height(rvcontentHeight);
  },
  rvcardsCarousel: function() {
    var $jcarousel = $('.ph-recentlyviewed-products__jcarousel');
    var rvinactive = 'ph-inactive';

    $jcarousel.on('jcarousel:reload jcarousel:create', function() {
      var $carousel = $(this),
          rvwidth = $carousel.innerWidth();

      if (rvwidth >= 768) {
        rvwidth = rvwidth / 4;
        ACC.common.setCarouselWidth($jcarousel, rvwidth, 4);
      } else if (rvwidth <= 768 && rvwidth >= 414) {
        rvwidth = rvwidth / 3;
      } else if (rvwidth <= 414) {
        rvwidth = rvwidth / 2;
      }

      $carousel.jcarousel('items').css('width', Math.ceil(rvwidth) + 'px');
    }).jcarousel({
      wrap: null
    });

    $('.ph-recentlyviewed-products__prevarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass(rvinactive);
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass(rvinactive);
    }).jcarouselControl({
      target: '-=1'
    });

    $('.ph-recentlyviewed-products__nextarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass(rvinactive);
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass(rvinactive);
    }).jcarouselControl({
      target: '+=1'
    });

    $('.ph-jcarousel-rv-pagination').jcarouselPagination({
      perPage: 3,
      item: function(page) {
        return '<a href="#' + page + '"><span class="ph-jcarousel-pagination-dot" data-page="' + page + '"></span></a>';
      }
    });

    $jcarousel.on('jcarousel:animateend', function() {
      ACC.recentlyviewedproducts.rvactivePage();
    });
  },
  rvactivePage: function() {
    var rvpageNumber = 1;
    var rvnavigationList = $('.ph-jcarousel-rv-pagination').find('a');
    var rvcompleteUrl = window.location.href;

    if (rvcompleteUrl.indexOf('#') !== -1) {
      rvpageNumber = rvcompleteUrl.split('#').splice(1, 1).join();
    }

    rvnavigationList.each(function() {
      $(this).find('span').removeClass('ph-active-page');

      if (('#' + rvpageNumber) === $(this).attr('href')) {
        $(this).find('span').addClass('ph-active-page');
      }
    });
  }
};
$(document).ready(function() {
  ACC.recentlyviewedproducts.rvbindAll();
});

